import React, { useState, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import panoViews from "../../constants/panoViews";
import "./style.css";

function SceneTestNavigator({ currentScene, onNavigate }) {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    setOpen(false);
  }, [currentScene]);

  const closeMenu = () => setOpen(false);

  return (
    <div
      className={`scene-test-nav${open ? " scene-test-nav--open" : ""}`}
      aria-label="Temporary scene test navigator"
    >
      <div className="scene-test-nav__fab-slot">
        {!open ? (
          <button
            type="button"
            className="scene-test-nav__trigger"
            onClick={() => setOpen(true)}
            aria-expanded={false}
            aria-haspopup="true"
            aria-label="Open scene test menu"
            title="Scene test (dev)"
          >
            <svg
              className="scene-test-nav__trigger-icon"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              aria-hidden
            >
              <rect className="scene-test-nav__bar" x="3" y="5" width="16" height="3" rx="1.5" />
              <rect className="scene-test-nav__bar" x="3" y="9.5" width="16" height="3" rx="1.5" />
              <rect className="scene-test-nav__bar" x="3" y="14" width="16" height="3" rx="1.5" />
            </svg>
          </button>
        ) : (
          <button
            type="button"
            className="scene-test-nav__close scene-test-nav__close--fab"
            onClick={closeMenu}
            aria-expanded={true}
            aria-controls="scene-test-nav-panel"
            aria-label="Close scene menu"
            title="Close"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden>
              <path
                className="scene-test-nav__close-icon"
                d="M5 5l10 10M15 5L5 15"
                fill="none"
                strokeWidth="2.25"
                strokeLinecap="round"
              />
            </svg>
          </button>
        )}
      </div>

      <CSSTransition
        nodeRef={panelRef}
        in={open}
        timeout={280}
        classNames="scene-test-nav-panel"
        unmountOnExit
      >
        <div
          ref={panelRef}
          id="scene-test-nav-panel"
          className="scene-test-nav__panel"
          role="menu"
          aria-labelledby="scene-test-nav-panel-title"
        >
          <div className="scene-test-nav__panel-header">
            <span className="scene-test-nav__panel-title" id="scene-test-nav-panel-title">
              Scenes
            </span>
          </div>
          <div className="scene-test-nav__panel-body">
            {panoViews.map((scene, index) => (
              <button
                key={`${scene.name}-${index}`}
                type="button"
                role="menuitem"
                className={`scene-test-nav__btn ${currentScene === index ? "scene-test-nav__btn--active" : ""}`}
                onClick={() => onNavigate?.(index)}
                aria-label={`Go to ${scene.name}`}
                title={scene.name}
              >
                {index}. {scene.name}
              </button>
            ))}
          </div>
        </div>
      </CSSTransition>
    </div>
  );
}

export default SceneTestNavigator;
